import { FormGroup, ValidatorFn, Validators } from "@angular/forms";

export function applyFormValidation(form: FormGroup, controlNames: string[], validators: ValidatorFn | ValidatorFn[] = [Validators.required]): void {
   Object.keys(form.controls).forEach(key => {
    const control = form.get(key);
    if (control) {
      if (controlNames.includes(key)) {
        control.setValidators([Validators.required]);
      } else {
        control.clearValidators();
        control.setErrors(null);
      }
      control.updateValueAndValidity();
    }
  });
}
